<template>
  <div class="user-machine-line-product jt-table">
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="$t('machineUser.devicePosition')"
      :visible.sync="dialogMachineMaps"
      width="75%"
      top="9vh"
      @closed="closeDialog"
      @open="handlerOpenDialog"
      :close-on-click-modal="false"
    >
      <div style="display: none">
        <input id="pac-input" class="controls" type="text" :placeholder="$t('machineConfig.pEnterMapTips')" />
      </div>
      <el-row>
        <div style="display: flex; align-items: center">
          <span>{{ $t("machineConfig.address") }}:</span>
          <div class="autocomplete-wrapper" ref="autocompleteContainer" style="flex: 1"></div>
        </div>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div style="margin-bottom: 10px">
            <span style="display: inline-block; min-width: 80px">{{ $t("machineConfig.mapLng") }}:</span>
            <el-input v-model="longitude" style="width: 150px; margin-left: 10px"></el-input>
          </div>
        </el-col>
        <el-col :span="24">
          <div style="">
            <span style="display: inline-block; min-width: 80px">{{ $t("machineConfig.mapLat") }}:</span>
            <el-input v-model="latitude" style="width: 150px; margin-left: 10px"></el-input>
          </div>
        </el-col>
      </el-row>

      <div id="infowindow-content">
        <div class="title" style="font-size: 18px">{{ place_name }}</div>
        <div style="width: 100%; display: flow-root; margin: 3px 0 2px 0">
          <strong>Place ID</strong>: <span>{{ place_id }}</span>
        </div>
        <div>{{ address }}</div>
        <div @click="handleJZ" style="color: blue; margin-top: 5px; text-decoration: underline; cursor: pointer">
          <span>Locate to the periphery</span>
          <span class="el-icon-s-promotion" style="margin-left: 3px; text-decoration: underline"></span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('')">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" :disabled="loadingForm" @click="submitForm()">{{ $t("common.definite") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { Loader } from "@googlemaps/js-api-loader";
  var map = null;
  var localGoogle = null;

  const loader = new Loader({
    apiKey: "AIzaSyA1Rd3GCCRnoZU1dmTRgFZoRaLcsq13BOw",
    version: "weekly",
    libraries: ["places"]
  });

  export default {
    name: "UserMachineMap",
    props: {
      dialogMachineMaps: Boolean,
      userEquipment: Object
    },
    data() {
      return {
        loading: false,
        longitude: "",
        latitude: "",
        address: "",
        place_id: "",
        place_name: "",
        fullscreenLoading: true,
        loadingForm: false
      };
    },
    methods: {
      handlerOpenDialog() {
        this.initMap();
        this.$nextTick(() => {
          this.initializeGoogleAutocomplete();
        });
      },
      async initializeGoogleAutocomplete() {
        const googleMaps = await loader.load();
        const placeAutocomplete = new googleMaps.maps.places.PlaceAutocompleteElement();

        const container = this.$refs.autocompleteContainer;
        if (container) {
          container.innerHTML = "";
          container.appendChild(placeAutocomplete);
        }

        placeAutocomplete.addEventListener("input", e => {
          if (!e.target.value) {
            this.latitude = "";
            this.longitude = "";
          }
        });

        placeAutocomplete.addEventListener("gmp-select", async ({ placePrediction }) => {
          const fullPlace = placePrediction.toPlace();
          await fullPlace.fetchFields({
            fields: ["location", "formattedAddress", "displayName"]
          });
          if (fullPlace.location) {
            this.latitude = fullPlace.location.lat();
            this.longitude = fullPlace.location.lng();
          }
          if (fullPlace.formattedAddress) {
            this.address = fullPlace.formattedAddress;
          } else if (fullPlace.displayName) {
            this.address = fullPlace.displayName;
          } else {
            this.address = placePrediction.description || "";
          }
        });
      },
      handleJZ() {
        let _self = this;
        var myLatlng = new localGoogle.maps.LatLng(parseFloat(_self.latitude), parseFloat(_self.longitude));
        map.setCenter(myLatlng);
        map.setZoom(18);
      },
      initMap() {
        let _self = this;
        if (_self.userEquipment.lng && _self.userEquipment.lat) {
          _self.latitude = parseFloat(_self.userEquipment.lat);
          _self.longitude = parseFloat(_self.userEquipment.lng);
        } else {
          _self.latitude = "";
          _self.longitude = "";
        }
      },
      cancel(state, code) {
        this.$emit("mapsCancel", false, state, code);
      },
      closeDialog() {
        this.$emit("mapsCancel", false);
      },
      submitForm() {
        let _self = this;
        if (_self.longitude && _self.latitude) {
          this.loadingForm = true;
          this.$api
            .request(this.$url.UserMachine.updatePos, this.$method.put, {
              id: _self.userEquipment.id,
              lng: parseFloat(_self.longitude),
              lat: parseFloat(_self.latitude),
              locale: _self.address
            })
            .then(res => {
              if (res.code === 0) {
                this.$notify({
                  title: this.$t("common.tip"),
                  message: this.$t("editUserMachine.up"),
                  type: "success"
                });
                this.$emit("addressUpdated", {
                  machineNo: _self.userEquipment.equipmentNo,
                  address: _self.address,
                  lat: _self.latitude,
                  lng: _self.longitude,
                  machineId: _self.userEquipment.id
                });
                this.$emit("mapsCancel", false, true);
              }
            })
            .catch(() => {
              this.$notify({
                title: this.$t("common.tip"),
                message: "reqest error",
                type: "warning"
              });
            })
            .finally(() => {
              this.loadingForm = false;
            });
        } else {
          this.$notify({
            title: this.$t("common.tip"),
            message: "xsxsxsx",
            type: "warning"
          });
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .search-box {
    width: 100%;
    padding: 10px;
    font-size: 16px;
  }
  .pac-container {
    z-index: 1000000 !important;
  }
  #mapBox {
    height: 100%;
  }
  .controls {
    background-color: var(--vtm-surface);
    border-radius: 2px;
    border: 1px solid transparent;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    box-sizing: border-box;
    font-family: Roboto;
    font-size: 15px;
    font-weight: 300;
    height: 29px;
    margin-left: 17px;
    margin-top: 10px;
    outline: none;
    padding: 0 11px 0 13px;
    text-overflow: ellipsis;
    width: 400px;
  }
  .controls:focus {
    border-color: #4d90fe;
  }
  .title {
    font-weight: bold;
  }
  #infowindow-content {
    display: none;
  }
  #mapBox #infowindow-content {
    display: inline;
  }
  .autocomplete-wrapper {
    padding: 16px;
    font-family: Roboto, sans-serif;
    max-width: 600px;
  }

  gmp-place-autocomplete {
    width: 100%;
    display: block;
    margin-bottom: 12px;
  }

  pre {
    background: #f6f8fa;
    padding: 10px;
    border-radius: 4px;
    overflow-x: auto;
  }
</style>
